'use strict';

module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify', function ($scope, ngDroUAA, ngDroUtilsNotify) {

        /**
         * Submit della form di modifica dei dati dell'utente.
         */
        $scope.registrySubmit = function (isValid) {
            if (isValid) {
                ngDroUAA.Profile.update($scope.person)
                        .then(function () {                            
                            angular.copy($scope.person, $scope.user);              // quello nella sidebar, visibile in tutta l'app               
                            ngDroUtilsNotify.updateSuccess($scope.person.firstName.sformat($scope.person.lastName));
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.updateError($scope.person.firstName.sformat($scope.person.lastName),err);
                        })
                        .finally(function () {

                        });
            }
        };
        
        // Chiusura della finestra.
        $scope.cancel = function () {
           angular.copy($scope.backupPerson, $scope.person);
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/profile/profileDetail/tabs/profile-form.js
// module id = 409
// module chunks = 0